import { useParams } from 'react-router';
import { UnitDetailsPanel } from '../Common/UnitDetailsPanel';
import { UnitWorkloadHeader } from '../Common/UnitWorkloadHeader';
import { UnitWorkloadNavigation } from '../Common/UnitWorkloadNavigation';
import { UnitWorkloadAssignment } from './UnitWorkloadAssignment';
import { useUnitWorkloadData } from '@/hooks';
import { Loader } from '@/components/Common/Loader';

export const UnitWorkloadDetailsView = () => {
  const { unitWorkloadId } = useParams();
  const uwId = unitWorkloadId ? parseInt(unitWorkloadId, 10) : null;
  if (uwId === null || isNaN(uwId)) {
    throw new Error('unitWorkloadId is required and must be a valid number');
  }

  // issue with URL
  if (!unitWorkloadId) {
    throw new Error('unitWorkloadId is required');
  }

  const { unitWorkloadDetails, unitWorkloadCampuses, sortedAssignedAcademics, campusList, isPageLoading } =
    useUnitWorkloadData(uwId);

  if (isPageLoading) {
    return <Loader />;
  }

  return (
    unitWorkloadDetails && (
      <div className="flex h-full w-screen flex-col items-start overflow-auto">
        <UnitWorkloadHeader unitWorkloadDetails={unitWorkloadDetails} />
        <UnitWorkloadNavigation unitWorkloadDetails={unitWorkloadDetails} />
        <div className="flex h-full w-screen flex-row items-stretch justify-start gap-14 overflow-auto bg-white">
          <UnitDetailsPanel unitWorkloadDetails={unitWorkloadDetails} />
          <UnitWorkloadAssignment
            unitWorkloadDetails={unitWorkloadDetails}
            unitWorkloadCampuses={unitWorkloadCampuses}
            assignedAcademics={sortedAssignedAcademics}
            campusList={campusList}
          />
        </div>
      </div>
    )
  );
};
